import Node from "#/decision_tree_viewer/components/Base/Node.vue";
import RadioButton from "#/decision_tree_viewer/components/Base/RadioButton.vue";
import Select from "#/decision_tree_viewer/components/Base/Select.vue";
import TileGrid from "#/decision_tree_viewer/components/Base/TileGrid.vue";
import TileGridItem from "#/decision_tree_viewer/components/Base/TileGridItem.vue";
import TextField from "#/decision_tree_viewer/components/Base/TextField.vue";
import HtmlContent from "#/decision_tree_viewer/components/Base/HtmlContent.vue";

const components = {
  Node,
  RadioButton,
  Select,
  TileGrid,
  TileGridItem,
  TextField,
  HtmlContent,
};

export const useBaseComponents = () => ({
  install(app) {
    for (const [name, component] of Object.entries(components)) {
      app.component(`Base${name}`, component);
    }
  },
});
